import React from "react";
import Header from "./Header";
import "../css/mediap.css";
import Footer from "./Footer";
function mediap() {
  return (
    <div>
      {" "}
      <Header></Header>
      <div className="section0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>Media & Press Information</h4>
              <p>Find out more about company, our services and our people.</p>
              <a href="/#" className="btn btn-outline-primary">
                GET MY FREE PROPOSAL{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="med">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p>
                For all media inquiries, please contact: <br />
                Matt Bowman <br />
                President, Thrive Internet Marketing Agency <br />
                <b>(843) 353-6383</b> <br />
                Matt Bowman Bio (Short): <br />
                Husband, father and 5th generation business owner. Matt loves
                helping others and helping businesses grow. He is the President
                and Founder of Thrive Internet Marketing Agency.
                <br />
                Matt Bowman Bio (Long): <br />
                Husband, father and 5th generation business owner. Matt loves
                helping others and seeing things grow. He is the President and
                Founder of Thrive Internet Marketing Agency. Thrive is a
                top-10-rated SEO agency, Google Premier Partner and Inc 5000
                fastest growing company in the US. The team at Thrive is
                passionate about using the power of the Internet to help
                businesses grow. For every new client we work with, Thrive gives
                a micro-loan to another striving entrepreneur through Kiva.org.
                <br />
                Company Description (Short): <br />
                Thrive Internet Marketing Agency is a top-10-rated SEO agency,
                Google Premier Partner and Inc 5000 fastest growing company in
                the US. The team at Thrive is passionate about using the power
                of the Internet to help businesses grow.
                <br />
                Company Description (Long): <br />
                Thrive Internet Marketing Agency is a top-10-rated SEO agency,
                Google Premier Partner and Inc 5000 fastest growing company in
                the US. The team at Thrive is passionate about using the power
                of the Internet to help businesses grow. For every new client we
                work with, Thrive gives a micro-loan to another striving
                entrepreneur through Kiva.org. Thrive boasts a unique,
                close-knit team with experts in all facets of digital marketing;
                strategic, creative and technical.
              </p>
              <br />
            </div>
            <div className="col-12">
              <p>
                <b>IMAGES</b>
              </p>
            </div>
            <div className="col-3">
              <img
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAHoAegMBIgACEQEDEQH/xAAbAAEAAwADAQAAAAAAAAAAAAAABQYHAQMEAv/EADgQAAIBAgMGAwQHCQAAAAAAAAABAgMEBQYRITFBcYHBElGRIlJh0RMksbLC0uEUMjM2QnKDkqH/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEQH/2gAMAwEAAhEDEQA/ANSABpkAAAAAAAAAAAAAAAAAAAAAAAAAAAABQABAAAAAAAAAAAAAADaS1b0SBWs6YjK3toWVKTjOum6jXueXXsB58ZzY4zlRwtRaWx15LXX+1d2QE8ZxOc/E7+41+E9F6I8ALEWHDc13lvNRvfrNLi9Eprk+PX1LpaXNG8t4V7aanTmtjRlRP5QxKVriCtZt/Q3D0092fB9d3oFXwAEAAAAAAAAAAADPc3Tc8erp7oRhFcvCn3NCKDnOi6eNzm1sq04yXRadgIIAGkD6pzdOpCpF6SjJSXNHyd1pRdxdUaMd9ScY+rJqtV112+YD3ggAAAAAAAAAAAQWbMKniFnGrbx1r0NWorfKPFc9hOgDJAaNieAYfiM5VatOVOq99Sk9G+fBkU8l0dfZvavh+NNPuUinFoybhU6ldYjWjpSp6qjr/VLdryW3ryJWyyph1vJTqupcyT3VH7Pou5OpJJJJJLYkuAHIAIAAAAAAAAABw3otXsQHJE4nmGww9um5utWW+nS26c3uRAZizLOvOVrh03Citk60d8+XkvtKyBY7nOF7UeltRo0Y8HJOT+X/AA8bzNizev7Ul/jj8iIBYifoZuxOm19IqNZeUoaP1TRN4fmyyuGoXUZWs/OT1g+vDqUUCDWoyU4qUWmntTT1TOTOcExy4wqoo7als37VJvd8Y+TNAtLmjeW8Li3mp05rVPtzIruAAAAAAAAKvnPFpUaaw63lpOpHWs090eC6/ZzLNOcacJTm9IxTlJ+SRlt7czvbutc1P3qs3LTyXBAdAAKgACgAABOZVxZ2F6qFWX1au0nq9kJcH2f6EGCauNbBG5evHfYRb1ZPWcV4J81s+T6kkQAAAAAEbmOq6OB3k1vdPw/7NLuZsaHm7+X7nnD78TPCmgAKgAAAAAAAC5ZDquVrd0vcqRl6p/lLSVDIP8S/5U/xFvIoACD/2Q=="
                alt=""
              />
            </div>
            <div className="col-3">
              <img
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAHoAegMBIgACEQEDEQH/xAAbAAEAAwADAQAAAAAAAAAAAAAABQYHAQMEAv/EADgQAAIBAgMGAwQHCQAAAAAAAAABAgMEBQYRITFBcYHBElGRIlJh0RMksbLC0uEUMjM2QnKDkqH/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEQH/2gAMAwEAAhEDEQA/ANSABpkAAAAAAAAAAAAAAAAAAAAAAAAAAAABQABAAAAAAAAAAAAAADaS1b0SBWs6YjK3toWVKTjOum6jXueXXsB58ZzY4zlRwtRaWx15LXX+1d2QE8ZxOc/E7+41+E9F6I8ALEWHDc13lvNRvfrNLi9Eprk+PX1LpaXNG8t4V7aanTmtjRlRP5QxKVriCtZt/Q3D0092fB9d3oFXwAEAAAAAAAAAAADPc3Tc8erp7oRhFcvCn3NCKDnOi6eNzm1sq04yXRadgIIAGkD6pzdOpCpF6SjJSXNHyd1pRdxdUaMd9ScY+rJqtV112+YD3ggAAAAAAAAAAAQWbMKniFnGrbx1r0NWorfKPFc9hOgDJAaNieAYfiM5VatOVOq99Sk9G+fBkU8l0dfZvavh+NNPuUinFoybhU6ldYjWjpSp6qjr/VLdryW3ryJWyyph1vJTqupcyT3VH7Pou5OpJJJJJLYkuAHIAIAAAAAAAAABw3otXsQHJE4nmGww9um5utWW+nS26c3uRAZizLOvOVrh03Citk60d8+XkvtKyBY7nOF7UeltRo0Y8HJOT+X/AA8bzNizev7Ul/jj8iIBYifoZuxOm19IqNZeUoaP1TRN4fmyyuGoXUZWs/OT1g+vDqUUCDWoyU4qUWmntTT1TOTOcExy4wqoo7als37VJvd8Y+TNAtLmjeW8Li3mp05rVPtzIruAAAAAAAAKvnPFpUaaw63lpOpHWs090eC6/ZzLNOcacJTm9IxTlJ+SRlt7czvbutc1P3qs3LTyXBAdAAKgACgAABOZVxZ2F6qFWX1au0nq9kJcH2f6EGCauNbBG5evHfYRb1ZPWcV4J81s+T6kkQAAAAAEbmOq6OB3k1vdPw/7NLuZsaHm7+X7nnD78TPCmgAKgAAAAAAAC5ZDquVrd0vcqRl6p/lLSVDIP8S/5U/xFvIoACD/2Q=="
                alt=""
              />
            </div>
            <div className="col-12">
              <p>
                We ask that you please do not modify our logos. You may resize
                them but please do not crop or modify the logos in any other
                way. The images are free to use for all media articles about
                Thrive Internet Marketing Agency. If you need a modified version
                please let us know.
              </p>
              <img
                src="https://thriveagency.com/files/awardimage2022-1-1.jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default mediap;
